import React, { useState } from 'react';
import AdminLayout from '../../../components/layout/AdminLayout';
import InvoiceLineItemForm from '../../../components/forms/InvoiceLineItemForm';
import { useInvoiceLineItemApi } from '../../../hooks/useInvoiceLineItemApi';
import { useNavigate } from 'react-router-dom';
import { InvoiceLineItemDTO } from '../../../services/apiClient';

const InvoiceLineItemCreate: React.FC = () => {
  const { create, isLoading } = useInvoiceLineItemApi();
  const navigate = useNavigate();
  const [isSubmitting, setIsSubmitting] = useState<boolean>(false);

  const breadcrumbs = [
    { label: 'Admin', href: '#' },
    { label: 'Invoice Line Items', href: '/admin/invoicelineitems' },
    { label: 'Create', href: '#' },
  ];

  const handleSubmit = async (data: InvoiceLineItemDTO) => {
    try {
      setIsSubmitting(true);
      await create(data);
      navigate('/admin/invoicelineitems');
    } catch (error) {
      console.error('Error creating InvoiceLineItem:', error);
    } finally{
      setIsSubmitting(false);
    }
  };

  return (
    <AdminLayout
      activeMenuItem="/admin/invoicelineitems"
      breadcrumbs={breadcrumbs}
      allowedRoles={['Admin']}
      requiredPermission='Settings.InvoiceLineItem.Edit'
    >
        <InvoiceLineItemForm
          initialValues={{} as InvoiceLineItemDTO}
          onSubmit={handleSubmit}
          onCancel={() => navigate('/admin/invoicelineitems')}
          isLoading={isSubmitting}
        />
    </AdminLayout>
  );
};

export default InvoiceLineItemCreate;